import { useQuery } from '@tanstack/react-query';
import { getAiAccuracy } from '../api/client';

export function useAiAccuracy(limit: number = 10) {
  return useQuery({
    queryKey: ['ai-accuracy', limit],
    queryFn: () => getAiAccuracy(limit),
    staleTime: 30_000,
  });
}
